// extracted by mini-css-extract-plugin
export default {"text":"_404_text__FKYUN","wrapper":"_404_wrapper__gQ400","backButton":"_404_backButton__cX0D2"};